import React from 'react'
import Header from '../component/Header'
import bg from '../rings.png'
import { motion } from "framer-motion";
import BoltIcon from '@mui/icons-material/Bolt';
import ShuffleIcon from '@mui/icons-material/Shuffle';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import PeopleIcon from '@mui/icons-material/People';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import featureThum from './../banner.png'
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';
import Footer from '../component/Footer';
import CodeIcon from '@mui/icons-material/Code';
import SettingsIcon from '@mui/icons-material/Settings';
import SpeedIcon from '@mui/icons-material/Speed';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import AutoModeIcon from '@mui/icons-material/AutoMode';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import apiProduct from '../apitype.png'

export default function Product() {
    const container = {
        hidden: {},
        visible: {
            transition: {
                staggerChildren: 0.18,
                delayChildren: 0.2,
            },
        },
    };

    const fadeUp = {
        hidden: {
            opacity: 0,
            y: 30,
        },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                duration: 0.6,
                ease: "easeOut",
            },
        },
    };
    const cardHover = {
        y: -6,
        boxShadow: "0px 20px 40px rgba(0,255,255,0.08)",
        transition: { duration: 0.3 },
    };

    const list = [
        {
            icon: < SpeedIcon />,
            title: 'CreditMetrics',
            desc: "Real-time credit scoring for faster decisions",
        },
        {
            icon: <CheckCircleOutlineIcon />,
            title: "VerifyPro",
            desc: "Automates KYC and document verification. ",
        },
        {
            icon: <AutoModeIcon />,
            title: "UnderwriteIQ",
            desc: "Enables instant, data-driven credit approvals.",
        },
        {
            icon: <VerifiedUserIcon/>,
            title: "FraudShield ",
            desc: "Detects and prevents fraud in real time.",
        },
        {
            icon: <TextSnippetIcon />,
            title: "ComplianceHub ",
            desc: "Keeps lending workflows compliant and secure.",
        },
        {
            icon: <CurrencyExchangeIcon />,
            title: "CollectionsCore ",
            desc: "Streamlines repayment and recovery processes.",
        },
        {
            icon: <ReportProblemIcon />,
            title: "RecoveryFlow",
            desc: "Recovers abandoned applications and leads.",
        },
        {
            icon: <VisibilityIcon />,
            title: "SupervisorAI ",
            desc: "Monitors operations and optimizes performance. ",
        },
    ];
    const values = [
        {
            title: "FraudGator",
            desc: "Advanced Fraud Intelligence to Detect, Prevent & Mitigate Risks.",
        },
        {
            title: "AccountGator",
            desc: "Banking Data Intelligence for Accurate Financial Assessment.",
        },
        {
            title: "LocaleGator",
            desc: "Location Intelligence for Accurate Risk Assessment & Seamless Customer Verification.",
        },



    ];
    const stats = [
        { value: "CredForge", label: "A powerful decision engine designed for real-time credit processing.", icon:<CodeIcon/> },
        { value: "MobileForge", label: "Device intelligence solution for deeper customer insights.", icon:<BoltIcon/> },
        { value: "PredForge", label: "Machine learning engine for advanced analytics and predictive modeling.", icon:<SettingsIcon/> },

    ];
    return (
        <>
            <Header />
            <div className="relative h-[320px] md:h-[400px] flex items-center justify-center overflow-hidden">

                {/* Background Image */}
                <div
                    className="absolute inset-0 bg-cover bg-no-repeat bg-fixed"
                    style={{ backgroundImage: `url(${bg})` }}
                />

                {/* Dark Overlay */}
                <div className="absolute inset-0 bg-gradient-to-b from-[#172f47]/100 to-[#12253c]/70" />

                {/* Animated Glow */}
                <div className="absolute w-[400px] h-[400px] bg-blue-400/20 rounded-full blur-3xl animate-pulse top-[-120px] left-[-120px]" />
                <div className="absolute w-[300px] h-[300px] bg-orange-400/20 rounded-full blur-3xl animate-pulse bottom-[-100px] right-[-100px]" />

                {/* Content */}
                <motion.div
                    initial={{ opacity: 0, y: 50 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8 }}
                    className="relative z-10 text-center px-6"
                >
                    {/* Title */}
                    <motion.h1
                        initial={{ opacity: 0, scale: 0.9 }}
                        whileInView={{ opacity: 1, scale: 1 }}
                        transition={{ delay: 0.2 }}
                        className="text-3xl sm:text-4xl md:text-5xl font-bold text-white"
                    >
                        Products &  <span className="text-[#00bd86]">Platforms</span>
                    </motion.h1>

                    {/* Subtitle */}
                    <motion.p
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.4 }}
                        className="mt-4 text-gray-200 text-sm sm:text-base max-w-xl mx-auto"
                    >
                        A unified ecosystem of AI agents, APIs, and decision engines designed to power secure, scalable, and intelligent lending.{" "}
                        {/* <span className="text-orange-400 font-semibold">
                            Your Company Name
                        </span> */}
                    </motion.p>
                </motion.div>
            </div>

            {/* service one start */}

            <section>
                <div className='max-w-7xl mx-auto py-20 gap-10 p-4'>
                     {/* <p className='text-[#00bd86] font-semibold'>AI Agents That Power Every Lending Decision</p> */}
                        <h4 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 leading-snug mb-4">
                          AI Agents
                        </h4>                        
                       <p>Intelligent AI agents designed to automate risk assessment, document verification, fraud prevention, collections, and customer engagement help lenders make faster, smarter, and more secure decisions at scale.</p>
                    
                   
                    <motion.div
                        variants={container}
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true }}
                        className="grid grid-cols-2 lg:grid-cols-4 gap-5"
                    >
                        {list.map((list, index) => (
                            <motion.div
                                key={index}
                                variants={fadeUp}
                                whileHover={cardHover}
                                className="p-6 border border-gray-300 rounded-lg mt-5"
                            >
                                {/* <img src={list.icon} alt='one' width={35} height={35} /> */}
                                <span className='p-3 text-white  bg-[#00bd86]' style={{ borderRadius: '50%' }}>{list.icon}</span>
                                <h3 className="text-lg font-semibold mb-3 pt-5">
                                    {list.title}
                                </h3>
                                <p className="text-gray-600 text-base pb-6">
                                    {list.desc}
                                </p>

                            </motion.div>
                        ))}
                    </motion.div>
                </div>
            </section>

            {/* end */}

            {/* Product 2 start */}
            <section className="relative py-16 sm:py-20 px-4 sm:px-6 bg-gradient-to-br from-slate-50 via-blue-50 to-purple-50 overflow-hidden">

                {/* Background blur */}
                <div className="absolute w-72 h-72 bg-blue-400/20 blur-3xl rounded-full top-10 left-10"></div>
                <div className="absolute w-72 h-72 bg-purple-400/20 blur-3xl rounded-full bottom-10 right-10"></div>

                <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-12 items-center relative z-10">

                    {/* LEFT SIDE */}
                    <div>
                        <p className='text-[#00bd86] font-semibold'>Build Faster. Integrate Smarter</p>
                        <h4 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 leading-snug mb-4">
                           LNVS Fintech API's
                        </h4>
                        
                        {/* <p>LNVS Fintech APIs enable seamless integrations for lending, payments, KYC, and credit scoring, delivering fast, secure, and scalable financial solutions for businesses.</p> */}
                        <div className="space-y-6">
                            {values.map((item, i) => (
                                <motion.div
                                    key={i}
                                    initial={{ opacity: 0, x: -40 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    transition={{ delay: i * 0.2, duration: 0.5 }}
                                    viewport={{ once: true }}
                                    className="group p-5 rounded-xl bg-white/40 backdrop-blur-lg border border-white/30 shadow-md hover:shadow-xl transition-all"
                                >
                                    <div className="flex justify-between items-start gap-4">
                                        <div>
                                            <h3 className="text-lg font-semibold text-slate-900">
                                                {item.title}
                                            </h3>
                                            <p className="text-sm text-slate-600 mt-1">
                                                {item.desc}
                                            </p>
                                        </div>

                                        {/* Arrow */}
                                        <span className="text-xl text-slate-400 group-hover:translate-x-1 group-hover:-translate-y-1 transition">
                                            <ArrowOutwardIcon />
                                        </span>
                                    </div>
                                </motion.div>
                            ))}
                        </div>
                    </div>

                    {/* RIGHT SIDE IMAGE */}
                    <motion.div
                        initial={{ opacity: 0, scale: 0.9 }}
                        whileInView={{ opacity: 1, scale: 1 }}
                        transition={{ duration: 0.6 }}
                        className="relative flex justify-center"
                    >
                        {/* Glass circle */}
                        <div className="absolute w-72 h-72 sm:w-96 sm:h-96 bg-white/30 backdrop-blur-xl rounded-full"></div>

                        {/* Image */}
                        <img
                            src={apiProduct} // replace with your image
                            alt="User"
                            className="relative object-cover"
                        />

                        {/* Floating animation */}
                        <motion.div
                            animate={{ y: [0, -10, 0] }}
                            transition={{ repeat: Infinity, duration: 3 }}
                            className="absolute -top-4 right-10 w-6 h-6 bg-blue-500 rounded-full"
                        />
                    </motion.div>

                </div>
            </section>
            {/* end */}

            {/* Product 3 start */}
            {/* <section className="relative overflow-hidden bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100 py-20 px-4">
                <div className="max-w-7xl mx-auto grid lg:grid-cols-1 gap-12 items-center">

                    
                    <div className="animate-fadeInUp">
                        <p className='text-[#00bd86] font-semibold'>Launch Faster. Scale Smarter.</p>
                        <h4 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 leading-snug mb-4">
                           Deployable Solutions
                        </h4>
                        <p>Ready-to-deploy solutions built for speed, flexibility, and performance—helping you go live quickly while maintaining security and scalability.</p>

                        <div className="grid grid-cols-1 lg:grid-cols-3 sm:grid-cols-2 gap-8">
                            {stats.map((item, index) => (
                                <div key={index} className="flex gap-5 animate-fadeUp mt-10"
                                    style={{ animationDelay: `${index * 0.2}s` }}>
                                    <div className="w-[2px] bg-gradient-to-b from-[#00bd86] to-transparent"></div>

                                    <div className='pt-2'>
                                        {item.icon}
                                        <h2 className="text-2xl sm:text-2xl font-semibold text-[#1e3a8a]">
                                            {item.value}
                                        </h2>
                                        <p className="text-gray-600 text-sm sm:text-base pt-2">
                                            {item.label}
                                        </p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                  




                </div>

               
                <style>{`
                                    @keyframes fadeInUp {
                                      from {opacity:0; transform:translateY(40px);}
                                      to {opacity:1; transform:translateY(0);}
                                    }
                            
                                    @keyframes fadeUp {
                                      from {opacity:0; transform:translateY(30px);}
                                      to {opacity:1; transform:translateY(0);}
                                    }
                            
                                    .animate-fadeInUp {
                                      animation: fadeInUp 0.8s ease forwards;
                                    }
                            
                                    .animate-fadeUp {
                                      opacity: 0;
                                      animation: fadeUp 0.8s ease forwards;
                                    }
                                  `}</style>
            </section> */}
          

            <Footer />
        </>
    )
}
